import { Component, Input, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type { MagazineDto } from '../../../../api/responses'

@Component({
  selector: 'dhp-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss'],
  imports: [TranslatePipe],
})
export class MoreInfoComponent {
  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() magazine!: MagazineDto
  readonly hideTitle = input(false)

  shouldShowSection(content: string | null | undefined): boolean {
    return !!content && content.trim().length > 0
  }
}
